module.exports = __webpack_public_path__ + "static/media/cdfi_logo.6ae360af.png";